import Sortable from "sortablejs";
import { post } from "./utils/api";
import { showModal, hideModal, showSuccessToast } from "./utils/ui";

document.addEventListener("DOMContentLoaded", () => {
  const kanbanColumns = document.querySelectorAll(".kanban-column");

  if (kanbanColumns.length > 0) {
    // Initial count update
    updateBadgeCounts();

    kanbanColumns.forEach((column) => {
      Sortable.create(column, {
        group: "kanban", // set both lists to same group
        animation: 150,
        ghostClass: "bg-gray-100", // Class name for the drop placeholder
        onEnd: async function (evt) {
          const itemEl = evt.item; // dragged HTMLElement
          const toColumn = evt.to; // target list

          const contactId = itemEl.getAttribute("data-id");
          const newStatus = toColumn.getAttribute("data-status");

          // If it didn't change columns, do nothing (or if it just reordered)
          if (evt.from === toColumn) {
            return;
          }

          // Update the status in the backend
          const response = await post(
            `/contact/api/status/${contactId}`,
            (() => {
              const fd = new FormData();
              fd.append("status", newStatus);
              return fd;
            })(),
          );

          if (response.ok) {
            // Update counts immediately
            updateBadgeCounts();

            // Check for trigger actions
            if (newStatus === "WIEDERVORLAGE" || newStatus === "TERMIN") {
              window.location.href = `/calendar?contactId=${contactId}&noModal=true`;
            }
          } else {
            console.error("Failed to update status");
            // Optional: Revert
            evt.from.appendChild(itemEl);
            updateBadgeCounts(); // update again in case of revert
          }
        },
      });
    });

    function updateBadgeCounts() {
      document.querySelectorAll(".kanban-column").forEach((column) => {
        const count = column.querySelectorAll(".kanban-item").length;
        const status = column.getAttribute("data-status");
        const badge = document.querySelector(`.kanban-count[data-status="${status}"]`);
        if (badge) {
          badge.textContent = count;
        }
      });
    }
  }

  // Handle Call Start
  document.addEventListener("click", async (e) => {
    const callBtn = e.target.closest(".call-start-btn");
    if (callBtn) {
      e.preventDefault();
      const contactId = callBtn.getAttribute("data-id");
      if (!contactId) return;

      const response = await post(`/contact/api/call/start/${contactId}`);
      if (response.ok) {
        window.location.reload();
      } else {
        console.error("Failed to start call");
      }
    }
  });
});
